import { SIZE, size } from 'assets/styles/ScreenSize';
import styled from 'styled-components/macro';
import { COLORS, FLEX_CONTAINER, FONTS, FONT_FAMILY } from 'utils/styles';

export const StepsSectionContainer = styled.div``;

export const StepsDescription = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};

  @media (min-width: ${SIZE.mobile}) {
    padding: 0 24px;
    ${FLEX_CONTAINER.FlexSpaceBetweenColumn}
    height: auto;
  }

  @media (min-width: ${SIZE.iphone}) {
    padding: 150px 40px;
  }

  @media (min-width: ${SIZE.tablet}) {
    padding: 150px 40px;
  }

  @media (min-width: ${SIZE.desktop}) {
    padding: 0 130px;
    flex-direction: row;
    align-items: flex-start;
  }

  @media (min-width: ${SIZE.bigDesktop}) {
    padding: 0 190px;
  }
`;

export const StartTrip = styled.div`
  @media (min-width: ${SIZE.mobile}) {
    margin-top: 70px;
  }
  @media (min-width: ${SIZE.iphone}) {
    margin-top: 40px;
  }
  @media (min-width: ${SIZE.tablet}) {
    margin-top: 50px;
  }
  @media (min-width: ${SIZE.desktop}) {
    margin-top: 148px;
  }
  @media (min-width: ${SIZE.bigDesktop}) {
    margin-top: 196px;
  }
`;

export const TripText = styled.p`
  ${FONTS.font24}
  ${FLEX_CONTAINER.FlexRow}
        ${FONT_FAMILY.FontMedium}
        color: ${COLORS.mainColor};
  max-width: 574px;
  width: auto;

  @media (min-width: ${SIZE.mobile}) {
    margin-bottom: 50px;
    ${FONTS.font14}
  }

  @media (min-width: ${SIZE.iphone}) {
    margin-bottom: 60px;
    ${FONTS.font16}
  }

  @media (min-width: ${SIZE.tablet}) {
    margin-bottom: 70px;
    ${FONTS.font16}
  }

  @media (min-width: ${SIZE.desktop}) {
    margin-bottom: 96px;
    ${FONTS.font20}
  }
  @media (min-width: ${SIZE.bigDesktop}) {
    margin-bottom: 143px;
    ${FONTS.font24}
  }
`;

export const StartButtonContnet = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow};

  @media (min-width: ${SIZE.desktop}) {
    ${FLEX_CONTAINER.FlexEndRow}
  }
`;

export const GlobalizationImage = styled.img`
  @media (min-width: ${SIZE.mobile}) {
    width: 270px;
    height: 270px;
    margin-top: 54px;
  }

  @media (min-width: ${size.mobileL}) {
    width: 368px;
    height: 368px;
    margin-top: 64px;
  }

  @media (min-width: ${SIZE.tablet}) {
    width: 488px;
    height: 488px;
    margin-top: 74px;
  }

  @media (min-width: ${SIZE.desktop}) {
    width: 558px;
    height: 558px;
    margin-top: 34px;
  }

  @media (min-width: ${SIZE.bigDesktop}) {
    width: 796px;
    height: 796px;
    margin-top: 50px;
  }
`;
